import { FeatureToggles } from './types';

export const DEFAULT_FEATURE_TOGGLES: FeatureToggles = {
  foundationDonations: false,
  DEIPages: false,
  richTextAssetBlocks: false,
  richTextEntryBlocks: false,
  richTextTables: false,
  sendGridEmails: false,
};
